"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});const e={styleOverrides:{button:({theme:r})=>({color:r.palette.grey[800]})}};exports.MuiPickersArrowSwitcher=e;exports.default=e;
